import React from 'react';
import ReactDOM from 'react-dom';

/**
 * Modal de confirmação reutilizável.
 * Uso: <ConfirmModal title="..." message="..." onConfirm={fn} onCancel={fn} danger />
 */
export default function ConfirmModal({ title, message, onConfirm, onCancel, danger = true, confirmLabel = 'Confirmar', cancelLabel = 'Cancelar' }) {
  return ReactDOM.createPortal(
    <div
      onClick={onCancel}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 99999, padding: '1rem',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: '#ffffff', borderRadius: '14px', padding: '1.5rem',
          maxWidth: '420px', width: '100%',
          boxShadow: '0 24px 64px rgba(0,0,0,.22)',
          animation: 'toastIn .2s ease',
        }}
      >
        <h3 style={{ margin: '0 0 0.5rem', fontSize: '1.05rem', fontWeight: 700, color: '#2f2a26' }}>
          {title}
        </h3>
        <p style={{ margin: '0 0 1.5rem', color: '#736b64', fontSize: '0.9rem', lineHeight: 1.5 }}>
          {message}
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.6rem' }}>
          <button
            onClick={onCancel}
            style={{
              padding: '0.55rem 1.1rem', background: '#ffffff', color: '#5a3e2b',
              border: '1px solid #f6f0ea', borderRadius: '8px',
              cursor: 'pointer', fontWeight: 600, fontSize: '0.88rem',
            }}
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '0.55rem 1.25rem',
              background: danger ? '#c46a60' : '#d4a574',
              color: '#ffffff', border: 'none', borderRadius: '8px',
              cursor: 'pointer', fontWeight: 600, fontSize: '0.88rem',
            }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
